import React, { useEffect, useRef, useState } from 'react';

import { getCookie } from '../../utils.js';

import { GoogleIcon } from '../../assets/icons';
import useGoogleLogin from '../../hooks/useGoogleLogin';
import { AltchaWidget } from '../Altcha';

import './GoogleLoginButton.css';

const DEFAULT_ERROR = 'Não foi possível entrar com o Google. Tente novamente.';
const ERROR_DURATION = 6000;

async function getApiErrorMessage(response) {
  try {
    const data = await response.json();
    const message = data && data.message;
    const action = data && data.action;

    return `${message} ${action}`;
  } catch (e) {}

  return DEFAULT_ERROR;
}

export default function GoogleLoginButton({ label, refetchUser }) {
  const altchaRef = useRef(null);
  const [, setAltchaPayload] = useState(null);
  const [, setVerifying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!error) return undefined;
    const timer = setTimeout(() => setError(null), ERROR_DURATION);
    return () => clearTimeout(timer);
  }, [error]);

  const { login } = useGoogleLogin({
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    onSuccess: async (code) => {
      setError(null);
      setLoading(true);
      try {
        const payload = await altchaRef.current.verify();
        if (!payload) {
          setError('Não foi possível validar o captcha. Tente novamente.');
          return;
        }

        if (!getCookie('csrftoken')) {
          await fetch(`${process.env.REACT_APP_SAFEAREA_BASE_API_URL}/safearea/api/v1/sessions/csrf/`, {
            method: 'GET',
            credentials: 'include',
          });
        }
        const response = await fetch(`${process.env.REACT_APP_SAFEAREA_BASE_API_URL}/safearea/api/v1/sessions/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCookie('csrftoken') || '' },
          credentials: 'include',
          body: JSON.stringify({ google_code: code, altcha_code: payload }),
        });

        altchaRef.current.reset();

        if (!response.ok) {
          setError(await getApiErrorMessage(response));
          return;
        }
        refetchUser();
      } catch (err) {
        setError(DEFAULT_ERROR);
      } finally {
        setLoading(false);
      }
    },
    onError: (err) => {
      if (err && err.type === 'popup_closed') return;

      setError(DEFAULT_ERROR);
    },
  });

  return (
    <div className="google_login">
      <button
        type="button"
        className={`google_button${loading ? ' google_button--loading' : ''}`}
        onClick={login}
        disabled={loading}
        aria-busy={loading}
      >
        {loading ? <span className="google_button__spinner" aria-hidden="true" /> : <GoogleIcon />}
        {label}
      </button>
      {error && (
        <span className="custom-tooltip" role="alert">
          <b className="error">{error}</b>
        </span>
      )}
      <AltchaWidget ref={altchaRef} onPayloadChange={setAltchaPayload} onVerifyingChange={setVerifying} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/GoogleLoginButton/index.jsx